import { possivelJSON } from '@utils/Format'

export const resolveAssetEditData = ({ assetItem, assetsList = [] }) => {
  const assetIdent = getAssetIdentifier({ assetItem })
  const found = assetIdent
    ? (assetsList || []).find(
        (a) => getAssetIdentifier({ assetItem: a }) === assetIdent
      ) || null
    : null

  const merged = { ...(assetItem || {}), ...(found || {}) }
  const Tipo = normalizeAssetType({ assetData: merged })

  return Tipo ? { ...merged, Tipo } : merged
}

export const extractFullWalletAssets = ({ fullWallet }) => {
  if (!fullWallet || typeof fullWallet !== 'object') return []

  return Object.values(fullWallet).flatMap((groupItem) => {
    const ativos =
      groupItem && groupItem.ativos
        ? parseAssetsList({ assetsData: groupItem.ativos })
        : []
    return Array.isArray(ativos) ? ativos : []
  })
}

export const normalizeAssetType = ({ assetData }) => {
  const assetType = (assetData && (assetData.Tipo || assetData.tipo)) || ''
  if (assetType === 'Saldo em conta') return 'Saldo em Conta'
  return assetType
}

export const buildEditPayload = ({ assetData }) => {
  return {
    Tipo: normalizeAssetType({ assetData }),
    corretora: assetData.Corretora || assetData.corretora,
    nome_ativo: assetData.nome_ativo,
    id_conta: assetData.id_conta,
    value: assetData,
  }
}

const getAssetIdentifier = ({ assetItem }) => {
  if (!assetItem) return null
  return (
    assetItem.id || assetItem.id_ativo_cliente || assetItem.id_ativo || null
  )
}

const parseAssetsList = ({ assetsData }) => {
  if (typeof assetsData === 'string') return possivelJSON(assetsData)
  return assetsData
}
